import { useEffect, useState } from "react";
import "@/App.css";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Hero from "@/components/card/Hero";
import SignatureMarquee from "@/components/card/SignatureMarquee";
import BentoDetails from "@/components/card/BentoDetails";
import ContactForm from "@/components/card/ContactForm";
import QRModal from "@/components/card/QRModal";
import { downloadVCard } from "@/components/card/vcard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FALLBACK = {
  name: "Hashim C. Favaz",
  firstName: "Hashim",
  lastName: "Favaz",
  title: "Management Consultant",
  company: "Hope Advisory",
  tagline: "Advisory & Management Consultancy.",
  email: "contact@hashimc.com",
  phone: "+971504608519",
  whatsapp: "+971569564918",
  enquiryEmail: "help@hopeadvisory.ae",
  location: "United Arab Emirates",
  website: "https://www.hopeadvisory.ae",
  websiteLabel: "www.hopeadvisory.ae",
  photoPath: "hope-card/media/profile.jpg",
  logoPath: "hope-card/media/logo.jpg",
};

function App() {
  const [card, setCard] = useState(FALLBACK);
  const [qrOpen, setQrOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    axios
      .get(`${API}/card`)
      .then((res) => setCard(res.data))
      .catch((e) => console.error("card fetch failed", e));
  }, []);

  const shareUrl = typeof window !== "undefined" ? window.location.href : "";

  const resolved = {
    ...card,
    photo: card.photoPath ? `${API}/files/${card.photoPath}` : card.photo,
    logo: card.logoPath ? `${API}/files/${card.logoPath}` : card.logo,
  };

  return (
    <div className="App bg-[#050505]">
      <div className="noise-overlay" />
      <Toaster theme="dark" position="bottom-center" />

      {/* Ambient glows */}
      <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 h-[500px] w-[500px] rounded-full bg-amber-500/10 blur-[140px]" />
        <div className="absolute top-1/2 -right-40 h-[500px] w-[500px] rounded-full bg-blue-600/15 blur-[150px]" />
      </div>

      <main className="relative z-10">
        <Hero
          card={resolved}
          onSave={() => downloadVCard(resolved)}
          onShare={() => setQrOpen(true)}
        />
        <SignatureMarquee card={resolved} />
        <BentoDetails
          card={resolved}
          onSave={() => downloadVCard(resolved)}
          onShare={() => setQrOpen(true)}
        />
        <ContactForm api={API} card={resolved} />
        <footer className="mx-auto max-w-6xl px-6 py-16 md:px-10">
          <div className="flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
            <span className="font-mono-accent text-xs uppercase tracking-widest text-white/40">
              © {new Date().getFullYear()} {resolved.name}
            </span>
            <span className="font-mono-accent text-xs uppercase tracking-widest text-white/40">
              {resolved.company} — Digital Card
            </span>
          </div>
        </footer>
      </main>

      <QRModal open={qrOpen} onClose={() => setQrOpen(false)} url={shareUrl} card={resolved} />
    </div>
  );
}

export default App;
